module.exports = __webpack_public_path__ + "img/Healthcare.b33cc554.svg";